import { routeName } from '@/constants/routeName';
import WorkerList from '@/views/WorkerManagement/WorkerList/index.vue';
import DeliveryFeeGroupSetting from '@/views/WorkerManagement/DeliveryFeeGroupSetting/index.vue';
import CashAutoDeductGroupSetting from '@/views/WorkerManagement/CashAutoDeductGroupSetting/index.vue';
import AllocatedCancelPenaltyGroupSetting from '@/views/WorkerManagement/AllocatedCancelPenaltyGroupSetting/index.vue';
import WorkerManagementWorkerCreate from '@/views/WorkerManagement/WorkerCreate/index.vue';
import WorkerManagementWorkerDetail from '@/views/WorkerManagement/WorkerDetail/index.vue';
import WorkerManagementWorkerEdit from '@/views/WorkerManagement/WorkerEdit/index.vue';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'worker-management',
        name: routeName.WORKER_MANAGEMENT,
        component: WorkerList,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'worker-management/delivery-fee-group-setting',
        name: routeName.WORKER_MANAGEMENT_DELIVERY_FEE_GROUP_SETTING,
        component: DeliveryFeeGroupSetting,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'worker-management/cash-auto-deduct-group-setting',
        name: routeName.WORKER_MANAGEMENT_CASH_AUTO_DEDUCT_GROUP_SETTING,
        component: CashAutoDeductGroupSetting,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'worker-management/allocated-cancel-penalty-group-setting',
        name: routeName.WORKER_MANAGEMENT_ALLOCATED_CANCEL_PENALTY_GROUP_SETTING,
        component: AllocatedCancelPenaltyGroupSetting,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'worker-management/create',
        name: routeName.WORKER_MANAGEMENT_WORKER_CREATE,
        component: WorkerManagementWorkerCreate,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'worker-management/:code',
        redirect: {
            name: routeName.WORKER_MANAGEMENT_WORKER_DETAIL,
        },
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'worker-management/:code/detail',
        name: routeName.WORKER_MANAGEMENT_WORKER_DETAIL,
        component: WorkerManagementWorkerDetail,
        meta: {
            ...basicOptions,
        },
    },
    {
        // (work-info|delivery-setting|private-info)',
        path: 'worker-management/:code/:type(work-info|delivery-setting|private-info)',
        name: routeName.WORKER_MANAGEMENT_WORKER_EDIT,
        component: WorkerManagementWorkerEdit,
        meta: {
            ...basicOptions,
        },
    },
];
